import { AbsoluteFill, useCurrentFrame, useVideoConfig, interpolate } from "remotion";
import React from "react";

// VFX: Aurora Wave Background
// Category: abstract-motion · Tags: background, aurora, waves, colorful, dark
export default function BgAuroraWavesColorfulLoop() {
  const frame = useCurrentFrame();
  const { durationInFrames, width, height } = useVideoConfig();
  const t = (frame / durationInFrames) * Math.PI * 2;
  const waves = [
    { color: "rgba(168,85,247,0.55)", phase: 0, amp: 80, freq: 1.0 },
    { color: "rgba(6,182,212,0.5)", phase: 1.1, amp: 100, freq: 1.3 },
    { color: "rgba(16,185,129,0.45)", phase: 2.3, amp: 70, freq: 1.6 },
    { color: "rgba(249,115,22,0.4)", phase: 3.4, amp: 90, freq: 0.8 },
  ];
  const path = (w: typeof waves[number]) => {
    const segs = 24;
    let d = `M 0 ${height * 0.5}`;
    for (let i = 0; i <= segs; i++) {
      const x = (i / segs) * width;
      const y = height * 0.5 + Math.sin(t * w.freq + (i / segs) * Math.PI * 2 + w.phase) * w.amp;
      d += ` L ${x} ${y}`;
    }
    d += ` L ${width} ${height} L 0 ${height} Z`;
    return d;
  };
  return (
    <AbsoluteFill style={{ background: "#0a0e1a" }}>
      <svg width={width} height={height} style={{ filter: "blur(30px)" }}>
        {waves.map((w, i) => (
          <path key={i} d={path(w)} fill={w.color} opacity={interpolate(Math.sin(t + i), [-1, 1], [0.5, 1])} />
        ))}
      </svg>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
